import React from 'react';
import {observer} from "mobx-react";
import {BETTING_CONTAINER} from "../../../betting-container-consts";
import {KeyboardArrowRight} from "../../../../../core/icons/keyboard-arrow/keyboard-arrow-right";
import {KeyboardArrowLeft} from "../../../../../core/icons/keyboard-arrow/keyboard-arrow-left";
import {useThemeColor} from "../../../../../infrastructure/hooks/useThemeColor";
import {COLORS} from "../../../../../core/app/consts/colors";

export const BettingZoneDrawerMenuItemPageArrow = observer(({item, controller}) => {
  const {device: {isRtl}} = controller;
  const isPageItem: Boolean = item.viewType === BETTING_CONTAINER.MENU_VIEW_TYPE.page;
  const assetsColor = useThemeColor(COLORS.textPrimary);

  const arrowProps = {
    color: assetsColor,
    style: {
      fill: assetsColor,
      width: 20,
      height: 20
    }
  }
  return isPageItem ? (isRtl ? <KeyboardArrowLeft {...arrowProps}/> : <KeyboardArrowRight {...arrowProps}/>) : null
});